import { RYDESEND_WEB_URL } from "../config/url.config"

async function superFetch (endpoint, method, data, token) {
    const response = await fetch(`${RYDESEND_WEB_URL}${endpoint}`, {
        method,
        headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: "Bearer " +token,
    },
        body: method === "get" ? undefined : JSON.stringify(data),
    });

    const res = await response.json();

    return res
}

export default superFetch ;